<template>
    <div>

        <div class="player-filter scoring-filter">

            <div class="player-filter__top">

                <div class="wrapper">

                    <div class="player-filter__left">

                        <div class="player-filter__switch">
                            <ul>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="type = 'atp'"
                                        :class="{ active: type == 'atp' }"
                                        href="#">
                                        <span>atp</span>
                                    </a>
                                </li>
                                <li>
                                    <a  class="general-button grey-blue generic-medium"
                                        @click.prevent="type = 'wta'"
                                        :class="{ active: type == 'wta'  }"
                                        href="#">
                                        <span>wta</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>

                    <div class="player-filter__right" ref="container" @mouseleave="handleMouseLeave">

                        <button  v-if="pdf_download"
                            class="general-button grey-blue generic-medium pdf_downloads"
                            @click="downloadClick"
                            ref="button">
                            <span v-html="ico_pdf"></span>
                            PDF downloads

                        </button>
                        <ul v-if="pdf_download" class="pdf_downloads__menu"
                            ref="menu"
                            @keydown="menuKeydown">
                            <li v-for="link in pdf_download">
                                <a :href="link.file" target="_blank">
                                    {{link.button_text}}
                                </a>
                            </li>
                        </ul>

                    </div>

                </div>

            </div>

            <div class="scoring-filter__separator"></div>

            <div class="player-filter__bottom">

                <div class="wrapper">

                    <div class="player-filter__type draws-rounds__mobile">
                        <label for="s2daySelector" class="vh">Day Selector</label>
                        <select v-model="selectedDay"
                                id="s2daySelector"
                                name="s2daySelector">
                            <!--<option :value="event" v-for="event in possibleEvents">{{event}}</option>-->
                        </select>
                    </div>

                    <div class="Draw-rounds" v-if="feed.length > 0">
                        <ul>
                            <li v-for="(day, dayIndex) in days" :key="dayIndex">
                                <button class="general-button generic-medium scoring-round"
                                        :class="{ selected: selectedDay == dayIndex+1 }"
                                        @click.prevent="selectedDay = dayIndex+1 "
                                        >
                                    <span>Day {{dayIndex + 1}}</span>
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>



        </div>

        <div class="wrapper">

            <div class="Results-matches grid two" v-if="matches.length > 0">

                <score-card v-if="showMatch(match)"
                            v-for="match in matches"
                            :match="match"
                            :flagPath="flagPath"
                            :key="match.id"
                            mode="result"
                            :detail="detail"
                            :data-id="match.id"
                            :type="pretype">
                </score-card>

            </div>

            <div class="na" v-else>
                <h2 class="na__title" style="margin-bottom: 0">
                    No results to show.
                </h2>
            </div>


        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import 'select2/dist/js/select2.full.js'

    import MatchCard from './MatchCard.vue'

    export default {
        props: ['pretype', 'flag', 'detail' , 'pdf'],
        components: {
            'score-card': MatchCard
        },
        data() {
            return {
                feed            : '',
                allMatches      : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                matches         : [],
                type            : '',
                days            : [],
                selectedDay     : '1',
                ico_pdf         : window.ico_pdf,
                pdf_download    : null,
                showDownloads   : false,
                assocQuery      : assocData.assocQueryVar

            }
        },
        created() {
            if(this.assocQuery){
                this.type = this.assocQuery
            }else{
                this.type = this.pretype
            }

            console.log(this.type)

            this.getFeed()
        },
        mounted() {
            let vm = this
            jQuery('#s2daySelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedDay = this.value
            })

            document.addEventListener('click', this.outsideClick);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.outsideClick);
        },
        computed: {
            // possibleEvents() {
            //     return this.getPossibleEvents()
            // }
        },
        watch: {
            type() {
                this.getFeed()
            },
            selectedDay(newValue, oldValue) {
                this.matches = this.getDateSeqMatches(newValue, this.allMatches)
            }
        },
        methods: {
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
            getOnlyFinishedMatches(matches) {
                return matches.filter(function (match) {

                    return match.detail.state == 'F' || match.drawInfo.result != ''

                })

            },
            getDateSeqMatches(dateSeq, matches) {
                return matches.filter(function (match) {
                    return match.detail.dateSeq == dateSeq
                })
            },
            getFeed() {
                this.getDraws()

                this.getOOPDays()
            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            },
            getOOPDays() {
                let app = this

                let url = `${window.feed_ip}/get/${this.type}/${window.tournament}/oop`

                axios.get( url ).then(response => {

                    let feed = response.data
                    let seq = 0

                    if (response.data.length > 0) {
                        seq = parseInt(response.data[0].seq)
                    }

                    let days = feed.map(day => {
                        return day.date
                    })
                    this.days = days

                    let seqDay            = days.length - 1 + seq
                    let currentSeqMatches = this.getDateSeqMatches(seqDay, this.allMatches)

                    if (currentSeqMatches.length == 0) {
                        this.selectedDay = seqDay - 1
                    } else {
                        this.selectedDay = seqDay
                    }

                    jQuery('#s2daySelector').empty().select2({
                        width: '100%',
                        data: days.map(function (day, index) {
                            return {
                                id: index + seq,
                                text: `day ${index + seq} - ` + app.formatDate(day)
                            }
                        })
                    }).val(this.selectedDay).trigger('change')

                }).catch(function (error) {
                    console.log(error)
                })

            },
            formatDate(day) {
                return moment(day).format('MMMM DD')
            },
            getDraws() {

                let url = `${window.feed_ip}/get/${this.type}/${window.tournament}/draws`

                axios.get( url ).then(response => {

                    this.feed = response.data

                    let allMatches      = this.getAllMatchesInOneArray(response.data)
                    let finishedMatches = this.getOnlyFinishedMatches(allMatches)


                    this.allMatches = finishedMatches
                    this.matches    = this.getDateSeqMatches(this.selectedDay, this.allMatches)

                }).catch(function (error) {
                    console.log(error)
                })


            },
            downloadClick(event) {
                let thisEl = jQuery(event.target),
                parentEl = thisEl.parent();

                if (parentEl.hasClass('open')) {
                    parentEl.removeClass('open').next().slideUp();
                } else {
                    jQuery('.drawer__nav .open').removeClass('open').next().slideUp();
                    parentEl.addClass('open').next().slideDown(() => {
                        parentEl.next().find('a:first').focus(); // Set focus on the first menu item
                    });
                }

                event.preventDefault(); // Prevent any default behavior
            },

            menuKeydown(event) {
                if (event.keyCode === 9 && event.shiftKey) { // Shift + Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[0]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                } else if (event.keyCode === 9 && !event.shiftKey) { // Tab key
                    const menuItems = jQuery(this.$refs.menu).find('a');
                    if (menuItems.length > 0 && document.activeElement === menuItems[menuItems.length - 1]) {
                        event.preventDefault();
                        jQuery(this.$refs.button).focus(); // Set focus on the button
                    }
                }
            },

            outsideClick(event) {
                const container = jQuery(this.$refs.container);
                if (!container.is(event.target) && !container.has(event.target).length) {
                    container.removeClass('open').find('.pdf_downloads__menu').slideUp();
                }
            },
            handleMouseLeave() {
                const container = jQuery(this.$refs.container)
                container.removeClass('open').find('.pdf_downloads__menu').slideUp();
            }
        }
    }
</script>
